// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  items: [
    {
      title: 'Dashboard',
      icon: 'mdi-view-dashboard',
      to: '/',
      items: [
        {
          title: 'Team Roster',
          to: '/components/roster',
          icon: 'mdi-account-group',
        },
        {
          title: 'Invoices',
          to: '/components/invoice',
          icon: 'mdi-currency-usd',
        },
        {
          title: 'Team Financials',
          to: '/',
          icon: 'mdi-chart-areaspline',
        },
        {
          title: 'Upcoming Scrim',
          to: '/components/scrim/',
          icon: 'mdi-google-controller',
        },
        {
          title: 'To Do List',
          to: '/components/activity/',
          icon: 'mdi-clipboard-list',
        },
        {
          title: 'Calendar',
          to: '/components/calendar/',
          icon: 'mdi-calendar',
        },
        {
          title: 'Team Comms',
          to: '/components/teamcomms',
          icon: 'mdi-file-plus',
        },
        {
          title: 'Inventory',
          to: '/components/inventory/',
          icon: 'mdi-devices',
        },
      ],
    },
    {
      title: 'Learning Room',
      icon: 'mdi-school',
      to: '/components/learning/',
    },
    {
      title: 'Team Stats',
      icon: 'mdi-chart-pie',
      to: '/',
    },
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
